export default "__VITE_PUBLIC_ASSET__098e474b__"